import { CloseOutlined } from "@ant-design/icons";
import { Button, Cascader } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { $t } from "~/i18n.js";

export const CompetencySelector = ({
  value,
  onChange,
  loading,
  onClear = null,
  allowMultiple = false,
  readOnly = false,
  ...props
}) => {
  const flights = useSelector((state) => state.flights);

  const competenties = flights.bevoegdheden
    .filter((cl) => !cl.is_dto)
    .map((cl) => ({
      value: cl.id,
      label: cl.label || cl.name,
      children: cl.category.map((cat) => ({
        value: cat.id,
        label: cat.label || cat.name,
        children: cat.bevoegdheid.map((b) => ({
          value: b.id,
          label: b.label || b.name,
        })),
      })),
    }));

  const triggerSelect = (selectedValues) => {
    // what we need to do is to make sure that we generate array's of complete of 3 levels
    // Ant Cascader returns an array of selected values, which can be of variable length depending on what the user clicked
    // we need to make sure we always return the complete path for each selected competency
    let finalValues = [];

    if (!allowMultiple) {
      // only return if length is 3
      if (selectedValues?.length === 3) {
        return onChange(selectedValues);
      } else {
        return onChange([]);
      }
    }

    selectedValues.forEach((valArr) => {
      if (valArr.length === 3) {
        finalValues.push(valArr);
      } else if (valArr.length === 2) {
        // find all children of this category
        const category = competenties
          .flatMap((c) => c.children)
          .find((cat) => cat.value === valArr[1]);
        if (category) {
          category.children.forEach((b) => {
            finalValues.push([valArr[0], valArr[1], b.value]);
          });
        }
      } else if (valArr.length === 1) {
        // find all children of this class
        const classItem = competenties.find((c) => c.value === valArr[0]);
        if (classItem) {
          classItem.children.forEach((cat) => {
            cat.children.forEach((b) => {
              finalValues.push([valArr[0], cat.value, b.value]);
            });
          });
        }
      }
    });

    return onChange(finalValues);
  };

  return (
    <>
      <Cascader
        loading={loading}
        style={{ width: "100%" }}
        placeholder={$t("Filter competentie")}
        options={competenties}
        disabled={readOnly}
        changeOnSelect
        showSearch
        value={value}
        multiple={allowMultiple}
        onChange={triggerSelect}
        allowClear={onClear ? false : true}
        {...props}
      />

      {onClear && (
        <Button size="small" onClick={onClear} icon={<CloseOutlined />} shape='circle' />
      )}
    </>
  );
};
